import { FormInstance, Typography } from 'antd';
import { FC, useEffect, useMemo, useState } from 'react';

import { Filter, FiltersForm, Filters, FilterItem } from 'componets/ui';

import { useAppSelector, useTranslate } from 'hooks';

import { FieldData, IFilter, IFilterValues } from 'models';
import Utils from 'utils/utils';
import { selectGlobals } from 'selectors';

import s from './index.module.scss';

type SecondaryMarketOffersFilterProps = {
	form: FormInstance;
	initialValues: IFilterValues;
	values: IFilterValues;
};
export const SecondaryMarketOffersFilter: FC<SecondaryMarketOffersFilterProps> = ({
	form,
	initialValues,
	values,
}) => {
	const t = useTranslate([
		'availableDealsText',
		'projectIdFilterText',
		'projectNameText',
		'withReducedPriceText',
		'interestRateText',
		'companyNameText',
		'projectTypeText',
		'filterNominalValueText',
		'mySalesText',
	]);

	const [fields, setFields] = useState<FieldData[]>([]);

	const pager = useAppSelector((state) => state.secondaryMarket.pager);
	const globals = useAppSelector(selectGlobals);

	const [filters, setFilters] = useState([] as IFilter[]);
	const [isOpen, setIsOpen] = useState(false);

	const typeOptions = useMemo(
		() =>
			globals.loanTypes?.map((item) => ({
				value: item.id,
				label: Utils.formatProjectType(item.type),
			})) || [],
		[globals.loanTypes],
	);

	const onResetFields = () => {
		form.setFieldsValue({
			type: '',
			loanId: '',
			projectTitle: '',
			'interestRate[from]': undefined,
			'interestRate[to]': undefined,
			reducedPriceOnly: 0,
			companyName: '',
			loanTermId: undefined,
			onlyAtNominalValue: undefined,
			onlyMySales: undefined,
		});
	};

	useEffect(() => {}, []);

	useEffect(() => {
		let data: IFilter[] = [];

		if (values) {
			data = Utils.transformFilters(values, [] as any, globals.loanTypes);
		}

		setFilters(data);
	}, [values]);

	const totalCount = pager.totalCount;

	return (
		<div>
			<div className={s.row}>
				{!!pager.currentPage && (
					<Typography.Text type="secondary" className={s.available}>
						{t.availableDealsText}: {totalCount}
					</Typography.Text>
				)}

				<div className={s.buttons}>
					<Filter
						onResetFields={onResetFields}
						isOpen={isOpen}
						onOpen={() => setIsOpen(true)}
						onClose={() => setIsOpen(false)}
					>
						<FiltersForm
							onFinish={() => setIsOpen(false)}
							fields={fields}
							form={form}
							initialValues={initialValues}
							setFields={setFields}
							values={values}
							filters={filters}
						>
							<FilterItem name="loanId" title={t.projectIdFilterText} isField />
							<FilterItem name="projectTitle" title={t.projectNameText} isField />

							<FilterItem name="companyName" title={t.companyNameText} isField />

							<FilterItem name="interestRate" title={t.interestRateText} isRange />

							<FilterItem
								name="reducedPriceOnly"
								title={t.withReducedPriceText}
								isSwitch
								checked={values?.reducedPriceOnly ? !!+values?.reducedPriceOnly : false}
								onClick={(value) => {
									setFields([
										{
											name: ['reducedPriceOnly'],
											value: value ? Number(value).toString() : '',
										},
									]);
								}}
							/>

							<FilterItem
								name="onlyAtNominalValue"
								title={t.filterNominalValueText}
								isSwitch
								checked={values?.onlyAtNominalValue ? !!+values?.onlyAtNominalValue : false}
								onClick={(value) => {
									setFields([
										{
											name: ['onlyAtNominalValue'],
											value: value ? Number(value).toString() : undefined,
										},
									]);
								}}
							/>
							<FilterItem
								name="onlyMySales"
								title={t.mySalesText}
								isSwitch
								checked={values?.onlyMySales ? !!+values?.onlyMySales : false}
								onClick={(value) => {
									setFields([
										{
											name: ['onlyMySales'],
											value: value ? Number(value).toString() : undefined,
										},
									]);
								}}
							/>

							<FilterItem
								title={t.projectTypeText}
								name="loanTermId"
								options={typeOptions}
								isCheckbox
							/>
						</FiltersForm>
					</Filter>
				</div>
			</div>
			<br />
			{filters.length > 0 && (
				<Filters filters={filters} onReset={onResetFields} form={form} values={values} />
			)}
		</div>
	);
};
